import { render, staticRenderFns } from "./NewReward.vue?vue&type=template&id=a5b25c7e&scoped=true&"
import script from "./NewReward.vue?vue&type=script&lang=js&"
export * from "./NewReward.vue?vue&type=script&lang=js&"
import style0 from "./NewReward.vue?vue&type=style&index=0&id=a5b25c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b25c7e",
  null
  
)

export default component.exports